declare namespace $ {

	type $mol_button_copy__theme_shm_hitalama_map_widget_float_prompt_1 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_copy['theme'] >
	>
	type $mol_button_copy__title_shm_hitalama_map_widget_float_prompt_2 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_copy['title'] >
	>
	type $mol_button_copy__text_shm_hitalama_map_widget_float_prompt_3 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_prompt['prompt'] >
		,
		ReturnType< $mol_button_copy['text'] >
	>
	export class $shm_hitalama_map_widget_float_prompt extends $shm_hitalama_map_widget_float_form_custom {
		prompt( ): string
		Copy( ): $mol_button_copy
		head( ): readonly(any)[]
		buttons( ): readonly(any)[]
	}
	
}

//# sourceMappingURL=prompt.view.tree.d.ts.map